<div class="w-full h-full relative">
  <slate-editable
    class="raw-sql-container"
    placeholder="Write your custom SQL here"
    [editor]="editor"
    [(ngModel)]="value"
    (ngModelChange)="valueChange($event)"
    [renderElement]="renderElement"
    [renderText]="renderText"
    (keydown)="onKeydown($event)"
  >
  </slate-editable>
  <ng-template #mention let-context="context" let-viewContext="viewContext">
    <span
      slateElement
      [context]="context"
      [viewContext]="viewContext"
      class="placeholder-pill"
      [ngClass]="{ focus: context.selection }"
    >
      {{ context.element.name }}
    </span>
  </ng-template>
  <div #suggestionList class="placholder-list">
    @for (item of suggestions; track $index; let i = $index) {
      <div
        (mousedown)="mousedown($event, item)"
        [ngClass]="{ active: i === activeIndex }"
      >
        {{ item }}
      </div>
    }
  </div>
</div>
